import React from 'react';
import classNames from 'classnames';
import metaBadge from 'assets/meta-badge.svg';
import securityBadge from 'assets/signup-security-badge.svg';
import g2Icon from './g2-icon.svg';

import css from './Badges.module.css';

type Props = {
  className?: string;
  isSignUp?: boolean;
};

export const Badges = ({ className, isSignUp }: Props) => {
  return (
    <div className={classNames(className, css.badges)}>
      <div className={isSignUp ? css.badgeWrapper : css.badgeWrapperNonSignUp}>
        <div className={css.badgeContainer}>
          <div className={css.badge}>
            <div className={css.leaderPennant}>
              <img src={g2Icon} className={css.g2Icon} />
            </div>
            <div className={css.badgeRow1}>Leader</div>
            <div className={css.badgeRow2}>Winter</div>
            <div className={css.badgeRow3}>2022</div>
          </div>
          <div className={css.badgeTriangle} />
        </div>
      </div>
      <div className={isSignUp ? css.badgeWrapper : css.badgeWrapperNonSignUp}>
        <img
          src={metaBadge}
          className={css.meta}
          alt="Meta Business Partner Badge"
        />
      </div>
      {isSignUp && (
        <div className={css.leftBadgeContainer}>
          <img className={css.securityBadge} src={securityBadge} />
          <div className={css.labelsContainer}>
            <div className={css.boldLabel}>14-day Free Trial</div>
            <div className={css.label}>No credit card required</div>
          </div>
        </div>
      )}
    </div>
  );
};
